









































































































import { Component } from 'vue-property-decorator'
import LayoutHeader from '@/category/LayoutHeader'

@Component
export default class extends LayoutHeader {}
